module.exports = __webpack_public_path__ + "static/img/404_cloud.0f4bc32b.png";